import styled from "styled-components";

import { FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const FilterContentContainer = styled(FlexColumn)`
    max-width: 263px;
    row-gap: 8px;
`;
